export default "__VITE_ASSET__0tLDBNw6__"